'use client';

import 'next-cloudinary/dist/cld-video-player.css';

import { CldVideoPlayer } from 'next-cloudinary';

interface WrappedVideoProps {
  src: string;
  dimensions: { width: number; height: number } | null;
  className?: string;
}

export const WrappedVideo = ({ src, dimensions, className }: WrappedVideoProps) => (
  <CldVideoPlayer src={src} width={dimensions?.width || 1} height={dimensions?.height || 1} className={className} />
);
